<!--资质荣誉-->
<template>
  <div class="new-box">
    <div class="page-banner flex-column-c-c">
      <div class="red-zz"></div>
      <div class="banner-en">Qualifications and honors</div>
      <div class="banner-title">资质荣誉</div>
      <div class="banner-line"></div>
    </div>
    <div class="honour-box">
      <div class="flex-e-sb w100per">
        <div class="honour-header">
          <div class="font70">HISTORY</div>
          <div class="font50">承包历程</div>
        </div>
<!--        <div class="honour-tab flex">-->
<!--          <a class="tab-item flex-c-c" :class="currentTab === 0 ? 'active' : ''" @click="currentTab = 0" href="#qyry">企业荣誉</a>-->
<!--          <a class="tab-item flex-c-c" :class="currentTab === 1 ? 'active' : ''" @click="currentTab = 1" href="#qyzz">企业资质</a>-->
<!--        </div>-->
      </div>
      <div class="honour-time" id="qyry">
        <div class="time-line pa"></div>
        <swiper class="w100per" :options="documentWidth < 750 ? swiperOptionApp : swiperOption" ref="mySwiper">
          <swiper-slide class="swiper-item swiper-slide-active" :class="item.year == currentTime ? 'swiper-slide-active' : ''" v-for="(item,index) in timeLine" :key="item.year" @click="handleToggle(item)">
            <div class="time-item flex-column-c-c">
              <div class="item-date">{{item.year}}年</div>
              <div class="item-circle"></div>
              <div class="item-title-active">{{item.title}}</div>
              <div class="item-white">
                <div class="item-icon"><img class="img-cover" src="../assets/honour/honour_icon.png" alt=""></div>
                <div class="item-title">{{item.title}}</div>
                <div class="item-intro">{{item.content}}</div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <div class="honour-card">
      <div class="honour-header">
        <div class="font70">APTITUDE</div>
        <div class="font50">企业资质</div>
      </div>
      <div class="flex-wrap card-list">
        <div class="card-item" v-for="(item,index) in flairList" :key="index">
          <el-image class="item-img" fit="scale-down" :src="`${ajaxUrl}${item.image}`" :preview-src-list="[`${ajaxUrl}${item.image}`]" @click="handleOpenPrev"></el-image>
          <!-- <PreImage class="item-img" width="100%" height="337px" fit="scale-down" :src="`${ajaxUrl}${item.image}`" :preview-src-list="flairList.map(i => `${ajaxUrl}${i.image}`)"/> -->
          <div class="item-title">{{item.title}}</div>
        </div>
      </div>
      <div class="honour-header">
        <div class="font70">HONOUR</div>
        <div class="font50">企业荣誉</div>
      </div>
      <div class="flex-wrap card-list">
        <div class="card-item" v-for="(item,index) in honorList" :key="index">
          <el-image class="item-img" fit="scale-down" :src="`${ajaxUrl}${item.image}`" :preview-src-list="[`${ajaxUrl}${item.image}`]" @click="handleOpenPrev"></el-image>
          <!-- <PreImage class="item-img" width="100%" height="337px" fit="scale-down" :src="`${ajaxUrl}${item.image}`" :preview-src-list="honorList.map(i => `${ajaxUrl}${i.image}`)"/> -->
          <div class="item-title">{{item.title}}</div>
        </div>
      </div>
    </div>
<!--    <MessageFrom></MessageFrom>-->
    <Footer></Footer>
  </div>
</template>

<script>
  import MessageFrom from "../components/MessageFrom";
  import {ajaxPost,ajaxGet,ajaxUrl} from "../utils/ajax";
  import Footer from "../components/Footer";
  import {downloadImage} from "../utils/tools";
  export default {
    name: "Honour",
    data(){
      return {
        ajaxUrl,
        currentTab: 0,
        timeLine:[],
        honorList:[],
        flairList:[],
        swiperOption:{
          // loop: true,
          slidesPerView: 5,
          spaceBetween: 50,
          autoplay: {
            disableOnInteraction: false,
            delay: 5000,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          centeredSlides:true,
          slideToClickedSlide: true,
          preloadImages: true,
        },
        swiperOptionApp:{
          // loop: true,
          autoplay: {
            disableOnInteraction: false,
            delay: 5000,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          centeredSlides:true,
          slideToClickedSlide: true,
          preloadImages: true,
        },
        currentTime: 2018,
        documentWidth: document.body.clientWidth,
      }
    },
    components: { Footer, MessageFrom },
    mounted() {
      this.$emit('handleRed', false);
      this.fetchCardList('honor','honorList');
      this.fetchCardList('flair','flairList');
    },
    methods: {
      handleOpenPrev(){
        this.$nextTick(() => {
              const func = document.getElementsByClassName('el-image-viewer__actions__inner');
              const downDom = document.createElement('i');
              downDom.className = 'el-icon-download';
              downDom.onclick = function () {
              const images = [...document.getElementsByClassName('el-image-viewer__img')];
              let url = '',name = '';
              images.forEach(a => {
                  if(a.style.display !== 'none') {
                  url = a.currentSrc;
                  name = url.split('/').slice(-1)[0].split('.')[0]
                  }
              });
              if(!!url){
                const w = window.open("about:blank");
                w.location.href = url;
              }
              }
              func[0].appendChild(downDom)
          })
      },
      fetchCardList(type,lis){
        ajaxGet({
          url: 'ajaxHonor',
          params:{ type,},
          success(res){
            const { code,data,msg} = res;
            if(code === 200){
              this.timeLine = data.timeline_list;
              this[lis] = data.honor_list;
            } else {
              this.$message.warning(msg);
            }
          }
        },this)
      },
      handleToggle(item) {
        this.currentTime = item.year;
      },
    },
  }
</script>

<style scoped lang="scss">
  .new-box {
    width: 100%;background: #F0F0F0;
    .page-banner {
      width: 100%;height: 730px;background: url('../assets/honour/honour_banner.png') no-repeat center/cover;padding-top: 2%;position: relative;padding-bottom: 100px;
      .red-zz { position: absolute;width: 100%;height: 230px;background: linear-gradient(180deg,rgba($theme-color,.7),transparent);top: 0;left: 0;z-index: 2;}
      .banner-title { font-size: 60px;color: $theme-color;letter-spacing: 1px;line-height: 1.1;margin-top: -55px;}
      .banner-en { font-size: 60px;color: $theme-color;letter-spacing: 1px;opacity: .1;text-transform: uppercase;}
      .banner-line { width: 110px;height: 3px;background: $theme-color;margin-top: 40px;}
    }
    .honour-box {
      width: 100%;padding: 50px 110px;background: #fff url('../assets/honour/honour_bg.png') no-repeat bottom left;
      .honour-tab {
        margin-bottom: 20px;
        .tab-item {
          width: 208px;height: 73px;background: rgba($theme-color,.4);color: #fff;margin-left: 28px;font-size: 16px;letter-spacing: 1px;
          &.active { background: $theme-color;}
        }
      }
    }
    .honour-header { color: $theme-color;line-height: 1.3;width: 100%;}
    .honour-time {
      position: relative;margin-top: 40px;height: 592px;
      .time-line { width: calc(100% - 57px);height: 2px;background: $theme-color;top: 93px;left: 28px;}
      .time-item {
        width: 202px;transition: .5s;
        .item-title-active { display: none}
        .item-intro { display: none;}
        .item-date { font-size: 30px;color: $theme-color;}
        .item-circle { margin: 40px 0;width: 18px;height: 18px;border-radius: 50%;background: $theme-color;}
        .item-title-active { font-size: 20px;color: $theme-color;margin-bottom: 14px;margin-top: -20px;}
        .item-white {
          padding: 34px 30px 50px 30px;background: $color-white;border-radius: 100px 0 100px 0;transition: .5s;
          .item-icon {width: 48px;height: 48px;margin: auto;}
          .item-title { margin-top: 26px;font-size: 20px;color: $theme-color;text-align: center;}
        }
      }
      >>> .swiper-slide-active {
        .time-item {
          width: 282px;
          .item-title { display: none;}
          .item-title-active { display: block;}
          .item-intro { display: block;margin-top: 14px;font-size: 14px;line-height: 1.8}
        }
      }
      >>> .swiper-button-next {
        width: 49px;height: 49px;border-radius: 50%;background: #D5B3AE;padding: 0;line-height: 38px;top: 92px;right: -20px;
        &:after { font-size: 20px;color: $theme-color}
        &:hover {
          background: $theme-color;
          &:after { color: #fff;}
        }
      }
      >>> .swiper-button-prev {
        width: 49px;height: 49px;border-radius: 50%;background: #D5B3AE;padding: 0;line-height: 38px;top: 92px;left: -20px;
        &:after { font-size: 20px;color: $theme-color}
        &:hover {
          background: $theme-color;
          &:after { color: #fff;}
        }
      }
    }
    .honour-card {
      padding: 70px 110px;width: 100%;background: url('../assets/honour/honour_bg2.png') no-repeat bottom right;
      .card-list {
        width: 100%;margin-bottom: 80px;
      }
      .card-item {
        width: 32%;margin-right: 2%;background: #FFFFFF;padding: 16px;margin-top: 30px;
        box-shadow: 0 9px 13px 0 rgba(127,127,127,0.73);transition: .3s;
        &:hover { transform: translateY(-4px);}
        &:nth-child(3n) { margin-right: 0;}
        .item-img { width: 100%;height: 337px;background: linear-gradient(0deg, #EEEEEE, #FAFAFA);}
        .item-title {font-size: 24px;text-align: center;margin-top: 20px;margin-bottom: 10px;}
      }
    }
  }
  @media screen and (max-width: 750px) {
    .new-box {
      .page-banner {
        height: 220px;padding-bottom: 0;padding-top: 8%;
        .red-zz { height: 100px;}
        .banner-en { display: none;}
        .banner-title { font-size: 26px;position: relative;z-index: 3;}
        .banner-line { width: 50px;height: 2px;margin-top: 10px;position: relative;z-index: 3;}
      }
      .honour-box {
        padding: 20px 14px;background: url("../assets/common_bg.png") no-repeat center/cover;
        .flex-e-sb { display: block;}
        .honour-tab { display: none;}
        .honour-time {
          height: auto;margin-top: 20px;
          .swiper-item { padding: 0 20px 10px 20px;}
          .time-line { top: 40px;height: 1px;width: calc(100% - 48px);left: 24px;}
          .time-item {
            width: 100%;
            .item-date { font-size: 18px;}
            .item-circle { width: 10px;height: 10px;margin: 8px 0 12px 0;}
            .item-title-active { margin-top: 0;font-size: 16px;}
            .item-white {
              box-shadow: 0 0 8px 0 rgba(0,0,0,.1);padding: 20px 20px;border-radius: 20px;
              .item-icon { width: 30px;height: 30px;}
              .item-intro { font-size: 13px;}
            }
          }
          >>> .swiper-button-next {
            width: 24px;height: 24px;line-height: 20px;top: 50px;right: 0;
            &:after { font-size: 12px;color: $theme-color}
            &:focus {
              background: $theme-color;
              &:after { color: #fff;}
            }
          }
          >>> .swiper-button-prev {
            width: 24px;height: 24px;line-height: 20px;top: 50px;left: 0;
            &:after { font-size: 12px;color: $theme-color}
            &:focus {
              background: $theme-color;
              &:after { color: #fff;}
            }
          }
        }
      }
      .honour-header {
        padding: 0;margin: 5px 0;
        .font70 { font-size: 32px;word-spacing: -1px;}
        .font50 { font-size: 24px;}
      }
      .honour-card {
        padding: 10px 14px 130px 14px;background: url('../assets/honour/honour_bg2.png') no-repeat bottom right;background-size: 250px auto;
        .card-list { margin-bottom: 30px;}
        .card-item {
          width: 49%;margin-right: 2%;padding: 8px;margin-top: 12px;
          &:nth-child(3n) { margin-right: 2%;}
          &:nth-child(2n) { margin-right: 0;}
          &:hover { transform: translateY(0);}
          .item-img {
            height: 130px;
          }
          .item-title { font-size: 14px;margin: 0;}
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Honour.vue